// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","BlogsPopularFeed":"kp_a bhv_px bhv_a bhv_w","BlogsPopularFeed__loading":"kp_b"};